import React, { useState } from 'react';
import { Grid, Card, CardMedia, makeStyles, Checkbox, Box, Stack, Button, Typography, IconButton } from '@material-ui/core';
import { Icon } from '@iconify/react';
import trash2Outline from '@iconify/icons-eva/trash-2-outline';
import axios from 'axios';
import { REST_API_END_POINT } from 'src/constants/Defaultvalues';
import { useSnackbar } from 'notistack';
import arrowLeftOutlined from '@iconify/icons-ant-design/arrow-left-outlined';
import arrowRightOutlined from '@iconify/icons-ant-design/arrow-right-outlined'; 
import Modal from './ProjectModel';
import AttachmentDownloadIconButton from 'src/components/_dashboard/official-request/AttachmentDownloadIconButton';
import AttachmentDownloadAllButton from 'src/components/_dashboard/official-request/AttachmentDownloadAllButton';

const useStyles = makeStyles((theme) => ({
    card: {
        borderRadius: theme.spacing(1),
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        position: 'relative', 
        cursor:'pointer'
    },
    delete:{
      m:2,
      display:'flex',
      justifyContent:'flex-end' 
    },
    media: {
        height: 0,
        paddingTop: '100%', 
        width: '100%',
        objectFit: 'fill', 
    },
    checkboxContainer: {
        position: 'absolute',
        top: theme.spacing(1),
        right: theme.spacing(1),
    },
    gridContainer: {
        height: '350px', 
        overflowY: 'auto', 
        paddingRight: '0.5rem',
        '&::-webkit-scrollbar': {
            width: '0.75rem',
          },
          '&::-webkit-scrollbar-track': {
            boxShadow: 'inset 0 0 6px rgba(110, 108, 108, 0.32)',
            webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'rgba(110, 108, 108, 0.32)',
            borderRadius: '4px',
          },
    },
}));

export default function ProjectImageAttach({images,setFetchData,projectId,setRefresh,refresh,designOrder,hideAddButton}) {
    let user = JSON.parse(localStorage.getItem('user'))
    const isClient = user?.isClient
    const userType = isClient ? 3 : user?.user_type
    const canDownloadFiles = !isClient && userType !== 3
    const explodedPermissions = user?.exploded_permissions
    const classes = useStyles();
    const {enqueueSnackbar}=useSnackbar() 
    const [checkedItems, setCheckedItems] = useState([]);
    const [openImageModal,setOpenImageModal] = useState(false)
    const [currentImageIndex, setCurrentImageIndex] = useState(null);
    
    const handleCheckboxChange = (id) => {
        console.log(id)
        setCheckedItems((prevState) => {
            const isPresent = prevState.includes(id);
            const updatedState = isPresent
              ? prevState.filter((item) => item !== id)
              : [...prevState, id];
            return updatedState;
          });   
    };

  const handleDelete=async()=>{
    try {
        let apiUrl = '';
        if(designOrder){
            apiUrl = `design-order-job/delete-attachment`
        }else{
            apiUrl = `project-task/delete-project-attachment`
        }
        const res = await axios.post(`${REST_API_END_POINT}${apiUrl}`,{
            userId:user.user_id,attachments:checkedItems,projectId, 
        })
        if(res.data.status===1){
            if(designOrder){
                setFetchData(true)
              }
            enqueueSnackbar(res.data.message,{variant:'success'}) 
            setRefresh(!refresh)
            setCheckedItems([])
        }else{
            enqueueSnackbar(res.data.message,{variant:'error'}) 
        }
    } catch (error) {
        console.log(error)
    }
  }

  const getAttachmentUrl = (attachment) =>
    attachment?.file_url ||
    attachment?.url ||
    attachment?.name ||
    attachment?.upload_file_name ||
    ''

  const attachmentToFile = (attachment) =>
    attachment
      ? {
          ...attachment,
          url: getAttachmentUrl(attachment),
          file_type: attachment.file_type,
          name: attachment.upload_file_name || attachment.name,
        }
      : null

  const handleImageClick = (index) => {
    setCurrentImageIndex(index);
    setOpenImageModal(true);
  };
  
    const handlePrevious = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : prevIndex));
  };

  const handleNext = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex < imageDesigns.length - 1 ? prevIndex + 1 : prevIndex));
  };
  
        const imageDesigns = images?.filter(
        (item) =>
          item.file_type?.startsWith('image/') ||
          item.file_type === 'img' ||
          item.file_type === 'image' ||
          getAttachmentUrl(item)
      );
    return (
        <Grid className={classes.gridContainer}> 
           <Box sx={{ mb: 2, display: 'flex', justifyContent: 'flex-end', gap: 2, mx: 2.5, alignItems: 'center' }}>
             {checkedItems.length > 0 && (
               <>
                 <Typography variant='subtitle1'>{checkedItems.length} selected</Typography>
                 <Button
                   disabled={ designOrder ? !explodedPermissions?.some((permission) => ['Delete Design from Design Order Job'].includes(permission)) : false }
                   onClick={()=>handleDelete()} className={classes.delete} size='small' variant='outlined'>
                    <Icon icon={trash2Outline} width={24} height={24} /> Delete
                 </Button>
               </>
             )}
             <AttachmentDownloadAllButton
               files={(images || [])
                 .filter((item) => checkedItems.includes(item.ID))
                 .map((item) => attachmentToFile(item))
                 .filter(Boolean)}
               allFiles={(images || []).map((item) => attachmentToFile(item)).filter(Boolean)}
               onToggleSelectAll={(checked) => {
                 setCheckedItems(
                   checked
                     ? (images || []).map((item) => item.ID).filter(Boolean)
                     : [],
                 )
               }}
               label="Download Selected"
               hidden={!canDownloadFiles || !(images?.length > 0)}
               size="small"
             />
           </Box>
                {images?.length>0 ?(
            <Grid container spacing={2}>
                {images?.map((image, index) => {
                    const imageUrl = getAttachmentUrl(image);
                    const fileName = imageUrl?.split('/').pop()?.split('?')[0] || '';
                    const fileExt = fileName.split('.').pop()?.toLowerCase();
                    const googleViewerFormats = ['eps','ai','psd','tif','tiff','bmp','ps','indd','indt'];
                    const isGoogleViewer = googleViewerFormats.includes(fileExt);

                    return (
                    <Grid key={image.ID} item xs={12} md={4} pb={4}>
                        <Card className={classes.card} sx={{ position: 'relative' }}>
                            <AttachmentDownloadIconButton
                              file={attachmentToFile(image)}
                              fileIndex={index}
                              hidden={!canDownloadFiles}
                              sx={{ position: 'absolute', top: 8, left: 8, zIndex: 12 }}
                            />
                            {isGoogleViewer ? (
                                <Box sx={{ position: 'relative', width: '100%', paddingTop: '100%' }}>
                                    <iframe
                                        src={`https://docs.google.com/gview?url=${encodeURIComponent(imageUrl)}&embedded=true`}
                                        title={fileName}
                                        width="100%"
                                        height="100%"
                                        frameBorder="0"
                                        sandbox="allow-scripts allow-same-origin"
                                        style={{ position: 'absolute', top: 0, left: 0, border: 'none', pointerEvents: 'none' }}
                                    />
                                    {/* Overlay to handle clicks over iframe */}
                                    <Box 
                                      sx={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', cursor: 'pointer' }}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        handleImageClick(imageDesigns.findIndex((img) => getAttachmentUrl(img) === imageUrl));
                                      }}
                                    />
                                </Box>
                            ) : (
                                <CardMedia
                                    className={classes.media}
                                    image={imageUrl}                              
                                    title={`Image ${imageUrl}`}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        handleImageClick(imageDesigns.findIndex((img) => getAttachmentUrl(img) === imageUrl))
                                    }}
                                />
                            )}
                            <Box className={classes.checkboxContainer}>
                                <Checkbox sx={{cursor:'pointer'}}
                                    checked={checkedItems.includes(image.ID) ? true : false}
                                    onChange={() => handleCheckboxChange(image.ID)}
                                    color="primary"
                                />
                            </Box>
                        </Card>
                    </Grid>
                    );
                })}
            </Grid>
            ):(
                <Box
              display={'flex'}
              justifyContent={'center'}
              alignItems={'center'}
              py={15}
            >
              No images found
            </Box>
                )}
                <Modal  width={1000}
              open={openImageModal}
              handleClose={() => {
                setOpenImageModal(false);
              }}
              modalTitle={'Designs'}
              >
              <Box display="flex" justifyContent="flex-end" mb={1}>
                <AttachmentDownloadIconButton
                  file={
                    currentImageIndex != null
                      ? attachmentToFile(imageDesigns[currentImageIndex])
                      : null
                  }
                  fileIndex={currentImageIndex ?? 0}
                  hidden={!canDownloadFiles}
                />
              </Box>
              <div
              style={{
                position: 'relative',
                width: '100%',
                height: '100%',
                display: 'flex',
                gap:'1rem',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
            <IconButton
              onClick={handlePrevious}
              disabled={currentImageIndex === 0}
              sx={{
                opacity: currentImageIndex === 0 ? 0.3 : 1,
                pointerEvents: currentImageIndex === 0 ? 'none' : 'auto',
              }}
            >
              <Icon
                icon={arrowLeftOutlined}
                width={24}
                height={24}
                color="#006097"
              />
            </IconButton>

            <Box
            component={'div'} 
              style={{
                width: '500px',
                height: '500px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                borderRadius: 8,
                overflow:'hidden'
              }}
            >
              {(() => {
                const currentUrl = getAttachmentUrl(imageDesigns[currentImageIndex]);
                if (!currentUrl) return null;
                const fileExt = currentUrl.split('/').pop()?.split('?')[0]?.split('.').pop()?.toLowerCase();
                const googleViewerFormats = ['eps','ai','psd','tif','tiff','bmp','ps','indd','indt'];
                const isGoogleViewer = googleViewerFormats.includes(fileExt);
                
                return isGoogleViewer ? (
                  <iframe
                    src={`https://docs.google.com/gview?url=${encodeURIComponent(currentUrl)}&embedded=true`}
                    title="Design Preview"
                    width="100%"
                    height="100%"
                    frameBorder="0"
                    sandbox="allow-scripts allow-same-origin"
                    style={{ border: 'none' }}
                  />
                ) : (
                  <img
                    src={currentUrl}
                    alt={`Image ${currentImageIndex + 1}`}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      borderRadius: 8,
                    }}
                  />
                );
              })()}
            </Box>
            <IconButton
              onClick={handleNext}
              disabled={currentImageIndex === imageDesigns.length - 1}
              sx={{
                opacity: currentImageIndex === imageDesigns.length - 1 ? 0.3 : 1,
                pointerEvents: currentImageIndex === imageDesigns.length - 1 ? 'none' : 'auto',
              }}
            >
              <Icon
                icon={arrowRightOutlined}
                width={24}
                height={24}
                color="#006097"
              />
            </IconButton>
          </div>
        </Modal>
        </Grid> 
    );
}
